import {Injector, ModuleWithProviders, NgModule} from '@angular/core';
import { AppComponent } from './app.component';
import {APP_BASE_HREF, CommonModule} from '@angular/common';

import { HomeComponent } from './components/home/home.component';
import { CoreJpatsModule } from './shared/core-jpats/core-jpats.module';
import { UiNdmsModule } from '../../shared/ui-ndms/ui-ndms.module';
import { McBreadcrumbsConfig } from 'ngx-breadcrumbs-ui';
import { ButtonChangeLocationComponent } from './components/button-change-location/button-change-location.component';
import { ModalChangeLocation } from './components/button-change-location/modal-change-location/modal-change-location.component';
import { ModalUpdateLocationComponent } from './components/button-change-location/modal-change-location/modal-update-location/modal-update-location.component';
import {ServiceLocator} from '../../shared/core/services/locator.service';
import {ApiConfiguration} from './api/api-configuration';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {JpatsAuthRequestInterceptor} from './shared/core-jpats/interceptors/auth-request.interceptor';
import {AuthApiService} from './shared/core-jpats/services/auth.service';
import {AuthModule, OidcSecurityService, Token} from 'angular-auth-oidc-client';
import {AuthorizedComponent} from './login/authorized/authorized.component';
import {AuthenticationGuard} from './shared/core-jpats/services/authentication.guard';
import {UserManagementService} from './shared/core-jpats/services/user-management.service';
import {LocationManagementService} from './shared/core-jpats/services/location-management.service';
import {FccManagementService} from './shared/core-jpats/services/fcc-management.service';
import {CoreJpatsServices} from './shared/core-jpats/services/core-jpats.services';
import {LoginModule} from './login/login.module';
import { HttpClientModule } from '@angular/common/http';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import {DatetimeService} from './shared/services/datetime.service';
import {PatientsHomeModule} from './patients/patients-home/patients-home.module';
import {AccessService} from './system-management/shared/service/access.service';
import {RoleConstants} from './system-management/shared/core/role.constants';
import {ImportsModule} from './imports/imports.module';
import {NdmsRouteResolverGuard} from '../../shared/core/services/ndms-route-resolver.guard';
import {PatientRegistrationService} from './patients/patient-registration/shared/services/patient-registration.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import {ModalAddFccComponent } from './components/button-change-location/modal-change-location/modal-update-location/modal-add-fcc/modal-add-fcc.component';
import {UiJpatsModule} from "./shared/ui-jpats/ui-jpats.module";
import {appNameFactory, appPathFactory, getBaseUrl, identityUrlFactory, siteMode,
  program, helpLink, helpEmail, helpNumber, information} from "./app.module.browser";
import {SystemManagementModule} from "./system-management/system-management.module";
import { SaveSearchService } from "../../shared/core/services/save-search.service";
import { UserPreferencesService } from "../../shared/core/services/user-preferences.service";

const providers = [
  AuthApiService ,
  OidcSecurityService,
  UserManagementService,
  FccManagementService,
  LocationManagementService,
  AccessService,
  RoleConstants,
  SaveSearchService,
  UserPreferencesService,
  AuthenticationGuard, CoreJpatsServices, DatetimeService, NdmsRouteResolverGuard, PatientRegistrationService,
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: 'ORIGIN_URL', useFactory: getBaseUrl },
    { provide: 'IDENTITY_URL', useFactory: identityUrlFactory },
    { provide: 'APP_PATH', useFactory: appPathFactory },
    { provide: 'APP_NAME', useFactory: appNameFactory },
    { provide: 'SITE_MODE', useFactory: siteMode},
    { provide: 'PROGRAM', useFactory: program },
    { provide: 'HELP_LINK', useFactory: helpLink },
    { provide: 'HELP_EMAIL', useFactory: helpEmail },
    { provide: 'HELP_NUMBER', useFactory: helpNumber },
    { provide: 'INFORMATION', useFactory: information}
];
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ModalChangeLocation,
    ModalUpdateLocationComponent,
    ModalAddFccComponent,
    AuthorizedComponent,
    PageNotFoundComponent
  ],
  providers:providers,
  imports: [
    CommonModule,
    CoreJpatsModule,
    UiNdmsModule,
    UiJpatsModule,
    LoginModule,
    HttpClientModule,
    PatientsHomeModule,
    ImportsModule,
    AuthModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
  ],
  entryComponents: [
    ModalChangeLocation,
    ModalUpdateLocationComponent,
    ModalAddFccComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModuleShared {}


@NgModule({})
export  class JpatsAppModuleShared{
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppModuleShared,
      providers: providers
    }
  }
}
